import { create } from 'zustand'

interface ModalDeletePropertyState {
  modalDeleteProperty: {
    isOpen: boolean
    propertiesIds: string[]
    title: string
    onSuccess?: () => void
  }
  setModalDeleteProperty: (modalDeleteProperty: {
    isOpen: boolean
    propertiesIds: string[]
    title: string
    onSuccess?: () => void
  }) => void
  reset: () => void
}

const initialState = {
  modalDeleteProperty: {
    isOpen: false,
    propertiesIds: [],
    title: ''
  }
}

export const useModalDeletePropertyStore = create<ModalDeletePropertyState>()(
  (set) => ({
    ...initialState,
    setModalDeleteProperty: (modalDeleteProperty) =>
      set({ modalDeleteProperty }),
    reset: () =>
      set({
        modalDeleteProperty: initialState.modalDeleteProperty
      })
  })
)
